<!-- <div class="container" fxLayout="column" *ngIf="payment">
  <h1>مثال</h1>
  <shared-discount
    style="width: 200px; padding: 0 0 30px 0"
    [preview]="true"
    [discountItem]="payment.discountType!"
  />
  <h1>به صورت JSON</h1>
</div>
<div class="container" *ngIf="!payment">
  <h1>پرداخت با مشکل مواجه شد</h1>
</div> -->

<div class="container">
  <div class="row">
    <div class="col-12">
      <div class="message-container">
        <ng-template [ngIf]="paymentStatus === 'OK'" [ngIfElse]="failedContainer">
          <img src="assets/image/success.png" />
          <span class="message-text">پرداخت موفقیت‌آمیز بود.</span>
          <button mat-raised-button [routerLink]="'/user/my-orders'">بازگشت به لیست سفارشات</button>
        </ng-template>
        <ng-template #failedContainer>
          <img src="assets/image/failed.png" />
          <span class="message-text failed">متاسفانه پرداخت ناموفق بود :(</span>
          <button mat-raised-button [routerLink]="'/user/my-orders'">بازگشت به لیست سفارشات</button>
        </ng-template>
      </div>
    </div>
  </div>
</div>
<app-footer />
